// extracted by mini-css-extract-plugin
export default {"lineThrough":"InstructionPrice_lineThrough__wRzE6","grayText":"InstructionPrice_grayText__PhgIF"};